const SNAP_EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@(c\.)?snap(chat)?\.com/;

export const isSnapchatEmail = (email: string): boolean => SNAP_EMAIL_REGEX.test(email);
